import React, { useEffect, useState } from 'react';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import axios from "axios";
import { Button } from "primereact/button";
import { Calendar } from "primereact/calendar";
import { addDays, format } from 'date-fns'
import "../../styles/memoryTrends.css"

function MemoryTrends() {

    const [start_date, setStartDate] = useState(null)
    const [end_date, setEndDate] = useState(null)

    const [trends, setTrends] = useState([])
    const [movies, setMovies] = useState([])

    const search = () => {
        searchSubjects()
        searchMovies()
    }

    const searchSubjects = async () => {
        const response_ranking_subjects = (await axios.post(
            `${process.env.REACT_APP_BASE_URL_ANALYTICS}/ranking_common_subjects_by_period`, 
            {
                start_date,
                end_date
            }
        )).data

        setTrends(response_ranking_subjects)
        return null
    }

    const searchMovies = async () => {
        const response_ranking_movies = (await axios.post(
            `${process.env.REACT_APP_BASE_URL_ANALYTICS}/ranking_movies_by_period`, 
            {
                start_date,
                end_date
            }
        )).data

        setMovies(response_ranking_movies)
        return null
    }

    const clear = () => {
        setStartDate(null)
        setEndDate(null)
    }

    return (
        <div>
            <div className="card">
                <h5>Analytics Filters</h5>
                <div className="analytics-filter">
                    <div className="analytics-field">
                        <label htmlFor="start-date">Start Date:</label>
                        <Calendar 
                            className="calendar-input"
                            id="start-date"
                            dateFormat="dd/mm/yy"
                            value={start_date}
                            onChange={(e) => {                                        
                                const startdate = new Date(e.target.value)
                                const isoDate = format(startdate, 'yyyy-MM-dd')
                                setStartDate(isoDate)
                            }}
                        /> 
                    </div>
                    {start_date && 
                        <div className="analytics-field">
                            <label htmlFor="end-date">End Date:</label>
                            <Calendar 
                                className="calendar-input"
                                id="end-date"
                                dateFormat="dd/mm/yy"
                                value={end_date}
                                minDate={start_date ? addDays(new Date(start_date), 1) : new Date(Date.now())}
                                viewDate={start_date ? addDays(new Date(start_date), 1) : new Date(Date.now())}
                                onChange={(e) => {
                                    const enddate = new Date(e.target.value)
                                    const isoDate = format(enddate, 'yyyy-MM-dd')
                                    setEndDate(isoDate)
                                }}
                            /> 
                        </div>
                    }
                    <div className="analytics-field">
                        <Button
                            label="Search"
                            icon="pi pi-search"
                            className="p-button-success mr-4"
                            onClick={search}
                        />
                        <Button
                            label="Clear"
                            icon="pi pi-trash"
                            className="p-button-danger mr-4"
                            onClick={clear}
                        />
                    </div>
                </div>
            </div>

            <div className="analytics-tables">
                <div className="card analytics-table">
                    <h5>Results</h5>
                    <DataTable
                        paginator
                        rows={10}
                        rowsPerPageOptions={[10, 25, 50]}
                        value={trends}
                        removableSort
                        scrollable
                        scrollDirection="both"
                        className="mt-3"
                    >
                        <Column field="subject" header="Trend" style={{width: '70%'}}></Column>
                        <Column field="count" header="Total times" style={{width: '30%'}}></Column>
                    </DataTable>
                </div>
                
                <div className="card analytics-table">
                    <h5>Recommended Movies</h5>
                    <DataTable
                        paginator
                        rows={10}
                        rowsPerPageOptions={[10, 25, 50]}
                        value={movies}
                        removableSort
                        scrollable
                        scrollDirection="both"
                        className="mt-3"
                    >
                        <Column field="movie" header="Movie" style={{width: '70%'}}></Column>
                        <Column field="count" header="Total times" style={{width: '30%'}}></Column>
                    </DataTable>
                </div>
            </div>
        </div>
    );
}

export default MemoryTrends;